/**
 * Exibe um tamanho de forma correta.
 * @param bytes Tamanho de entrada.
 * @returns
 */
export function formatBytes(bytes: number) {
  const units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  let index = 0;

  while (bytes >= 1024 && index < units.length - 1) {
    bytes /= 1024;
    index++;
  }

  return `${bytes.toFixed(2)} ${units[index]}`;
}

/**
 * Aplica máscara monetária brasileira (R$ 0,00) em um valor.
 * @param value Valor a ser formatado (string ou number).
 * @returns Valor formatado como string (ex: "R$ 1.234,56").
 */
export function formatarMoeda(value: string | number | undefined | null): string {
  if (value === undefined || value === null || value === '') {
    return '';
  }

  // Converte para número se for string
  const numero = typeof value === 'string' ? parseFloat(value.replace(/[^\d,.-]/g, '').replace(',', '.')) : value;
  
  if (isNaN(numero)) {
    return '';
  }

  // Formata como moeda brasileira
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numero);
}

/**
 * Aplica máscara monetária durante a digitação (formato: R$ 0,00).
 * @param value Valor digitado pelo usuário.
 * @returns Valor formatado com máscara monetária.
 */
export function aplicarMascaraMoeda(value: string): string {
  if (!value) return '';

  // Remove tudo que não é dígito (incluindo R$, espaços, pontos e vírgulas)
  const apenasDigitos = value.replace(/\D/g, '');

  if (apenasDigitos === '') return '';

  // Converte para número (centavos)
  // Exemplo: "1234" -> 12.34 (R$ 12,34)
  const numero = parseFloat(apenasDigitos) / 100;

  // Formata como moeda brasileira
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numero);
}

/**
 * Remove a máscara monetária e retorna o valor numérico.
 * @param value Valor formatado com máscara monetária.
 * @returns Valor numérico (ex: "R$ 1.234,56" retorna 1234.56).
 */
export function removerMascaraMoeda(value: string): number {
  if (!value) return 0;

  // Remove símbolos e formata para número
  const valorLimpo = value
    .replace(/R\$/g, '')
    .replace(/\./g, '')
    .replace(',', '.')
    .trim();

  const numero = parseFloat(valorLimpo);
  return isNaN(numero) ? 0 : numero;
}